import {dialogsSelector, trainingsSlice} from "../../../store/slice";
import {useSliceDialogsWithActions} from "../../../../../../newShared/hooks/useSliceDialogsWithActions";

const slice = trainingsSlice;
export const useTrainingsDialogs = () => useSliceDialogsWithActions(slice.actions, dialogsSelector);